import * as Sentry from '@sentry/vue';
import {
   SENTRY_PRIVACY_OPTIONS,
   resolveSentryEnvironment,
   shouldInitSentry,
} from '~/utils/sentryConfig';
export default defineNuxtPlugin({
   name: 'sentry',
   dependsOn: ['acquisition-entry'],
   parallel: true,
   async setup(nuxtApp) {
      const vueApp = nuxtApp.vueApp;

      const config = useRuntimeConfig();
      const router = useRouter();
      const hostname = window.location.hostname;
      const appEnv = config.public.APP_ENV as string | undefined;
      if (shouldInitSentry({ isDev: import.meta.dev, hostname, appEnv }))
         Sentry.init({
            app: vueApp,
            dsn: config.public.SENTRY_DSN_PUBLIC as string,
            environment: resolveSentryEnvironment({
               appEnv,
               apiBaseUrl: config.public.API_BASE_URL as string | undefined,
               hostname,
               nodeEnv: config.public.NODE_ENV as string | undefined,
            }),
            integrations: [
               Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
               Sentry.browserTracingIntegration({
                  router,
                  routeLabel: 'path',
               }),
               Sentry.breadcrumbsIntegration({
                  console: true,
                  dom: true,
                  fetch: true,
                  history: true,
                  xhr: false,
               }),
            ],
            // Privacy settings (no PII, no props, no replay, scrubbed URLs and breadcrumbs).
            // Replay masking stays on so raising a rate later cannot record text or media.
            ...SENTRY_PRIVACY_OPTIONS,
         });
   },
});
